import { AppConfig } from "../app-config";

export const PRODUCTION_CONFIG: AppConfig = {
    weightSymbol: 'lb',
    siteHost:`https://nest-typeorm.herokuapp.com`,
}